/* eslint-disable global-require */
const brand = {
  qa: {
    "4njbets": require("./qa/4njbets"),
    iowa: require("./qa/iowa"),
    pabets: require("./qa/pabets"),
    tvg: require("./qa/tvg"),
    fdr: require("./qa/fdr"),
    base: require("./qa/base")
  },
  staging: {
    "4njbets": require("./staging/4njbets"),
    iowa: require("./staging/iowa"),
    pabets: require("./staging/pabets"),
    tvg: require("./staging/tvg"),
    fdr: require("./staging/fdr"),
    base: require("./staging/base")
  },
  production: {
    "4njbets": require("./production/4njbets"),
    iowa: require("./production/iowa"),
    pabets: require("./production/pabets"),
    tvg: require("./production/tvg"),
    fdr: require("./production/fdr"),
    base: require("./production/base")
  },
  "aws-int": {
    "4njbets": require("./aws-int/4njbets"),
    iowa: require("./aws-int/iowa"),
    pabets: require("./aws-int/pabets"),
    tvg: require("./aws-int/tvg"),
    fdr: require("./aws-int/fdr"),
    base: require("./aws-int/base")
  },
  "aws-stg": {
    "4njbets": require("./aws-stg/4njbets"),
    iowa: require("./aws-stg/iowa"),
    pabets: require("./aws-stg/pabets"),
    tvg: require("./aws-stg/tvg"),
    fdr: require("./aws-stg/fdr"),
    base: require("./aws-stg/base")
  },
  "aws-prd": {
    "4njbets": require("./aws-prd/4njbets"),
    iowa: require("./aws-prd/iowa"),
    pabets: require("./aws-prd/pabets"),
    tvg: require("./aws-prd/tvg"),
    fdr: require("./aws-prd/fdr"),
    base: require("./aws-prd/base")
  },
  "aws-loadtest": {
    "4njbets": require("./aws-loadtest/4njbets"),
    iowa: require("./aws-loadtest/iowa"),
    pabets: require("./aws-loadtest/pabets"),
    tvg: require("./aws-loadtest/tvg"),
    fdr: require("./aws-loadtest/fdr"),
    base: require("./aws-loadtest/base")
  }
};

export default brand;
